import React from 'react';
import Icon from '../../../components/AppIcon';

const MaintenanceSchedule = ({ schedule }) => {
  const getTypeConfig = (type) => {
    const configs = {
      preventive: { label: 'Préventive', className: 'bg-primary/10 text-primary', icon: 'Calendar' },
      corrective: { label: 'Corrective', className: 'bg-warning/10 text-warning', icon: 'Wrench' },
      emergency: { label: 'Urgence', className: 'bg-error/10 text-error', icon: 'AlertTriangle' }
    };
    return configs?.[type] || configs?.preventive;
  };

  const getStatusConfig = (status) => {
    const configs = {
      scheduled: { label: 'Planifiée', className: 'bg-muted text-muted-foreground', icon: 'Clock' },
      in_progress: { label: 'En cours', className: 'bg-warning/10 text-warning', icon: 'Play' },
      completed: { label: 'Terminée', className: 'bg-success/10 text-success', icon: 'CheckCircle' }
    };
    return configs?.[status] || configs?.scheduled;
  };

  const getPriorityConfig = (priority) => {
    const configs = {
      high: { label: 'Haute', className: 'text-error' },
      medium: { label: 'Moyenne', className: 'text-warning' },
      low: { label: 'Basse', className: 'text-success' }
    };
    return configs?.[priority] || configs?.medium;
  };

  const formatDate = (dateString) => {
    return new Date(dateString)?.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  const sortedSchedule = [...schedule]?.sort((a, b) => 
    new Date(a?.scheduledDate) - new Date(b?.scheduledDate)
  );

  return (
    <div className="bg-card border border-border rounded-lg p-5">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-foreground">Planning de Maintenance</h2>
        <Icon name="Calendar" size={20} className="text-muted-foreground" />
      </div>

      <div className="space-y-3">
        {sortedSchedule?.map(maintenance => {
          const typeConfig = getTypeConfig(maintenance?.type);
          const statusConfig = getStatusConfig(maintenance?.status);
          const priorityConfig = getPriorityConfig(maintenance?.priority);

          return (
            <div key={maintenance?.id} className="p-4 bg-muted/30 rounded-lg hover:bg-muted/50 transition-colors duration-200">
              <div className="flex items-start justify-between mb-3">
                <div className="flex-1">
                  <h4 className="text-sm font-semibold text-foreground mb-1">{maintenance?.machineName}</h4>
                  <p className="text-xs text-muted-foreground">{maintenance?.description}</p>
                </div>
                <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${statusConfig?.className}`}>
                  <Icon name={statusConfig?.icon} size={12} />
                  {statusConfig?.label}
                </span>
              </div>

              <div className="grid grid-cols-2 gap-3 mb-3">
                <div className="flex items-center gap-2">
                  <Icon name="Calendar" size={14} className="text-muted-foreground" />
                  <span className="text-xs text-foreground">{formatDate(maintenance?.scheduledDate)}</span>
                </div>
                <div className="flex items-center gap-2">
                  <Icon name="Clock" size={14} className="text-muted-foreground" />
                  <span className="text-xs text-foreground">{maintenance?.estimatedDuration}</span>
                </div>
              </div>

              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <Icon name="User" size={14} className="text-muted-foreground" />
                  <span className="text-xs text-foreground">{maintenance?.technician}</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium ${typeConfig?.className}`}>
                    <Icon name={typeConfig?.icon} size={12} />
                    {typeConfig?.label}
                  </span>
                  <span className={`text-xs font-medium ${priorityConfig?.className}`}>
                    Priorité {priorityConfig?.label}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MaintenanceSchedule;